<template>
	<div class="content-box">
		<div class="banner">
			<div class="banner_title">
				<div class="big">
					漏洞统计
				</div>
				<div class="min">
					查看漏洞变化趋势
				</div>
			</div>
		</div>
		<div>
			<!-- 数量统计 -->
			<div class="quantity-statistics-box">
				<div class="width-1200">
					<div class="number-list" @click="jumpListAll()">
						<div>
							<p class="number-name">漏洞总数</p>
							<p class="num-total" style="color: #000000;">{{this.vulnerabilityInfos.total}}</p>
						</div>
					</div>
					<div class="number-list" @click="jumpList(1)">
						<p class="number-name">高危漏洞</p>
						<p class="num-total" style="color: #f34f4e;">{{this.vulnerabilityInfos.high}}</p>
					</div>
					<div class="number-list" @click="jumpList(2)">
						<p class="number-name">中危漏洞</p>
						<p class="num-total" style="color: #eebd34;">{{this.vulnerabilityInfos.middle}}</p>
					</div>
					<div class="number-list1" @click="jumpList(3)">
						<p class="number-name">低危漏洞</p>
						<p class="num-total" style="color: #009ef3;">{{this.vulnerabilityInfos.low}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="mainWidth">
			<div class="echarts_c">
				<div class="echarts-line">
					<div class="line_title">
						<img src="../../assets/image/icon/line.png" style="width: 14px;height: 11px;margin-right: 8px;" />
						<span>漏洞趋势</span>
					</div>
					<p style="margin-top: 10px;">
						<span>日期：</span>
						<a-range-picker :default-value="[this.$moment(this.beginDate, dateFormat), this.$moment(this.endDate, dateFormat)]"
						 :format="dateFormat" @change="onChange" :allowClear="false" />
					</p>
					<div id="echartLine" style="width: 100%;height: 100%;"></div>
					<p class="description">
						从{{this.beginDate}}到{{this.endDate}}
						，累计新增漏洞{{total}}条
						<!-- ，平均每天新增{{midNum}}条 -->
						，新增漏洞数最高的日期为{{maxDate}}。
					</p>
				</div>
				<div class="echarts-pie">
					<div class="pie_title">
						<img src="../../assets/image/icon/pie.png" style="width: 14px;height: 14px;margin-right: 8px;" />
						<span>漏洞危害等级分布</span>
					</div>
					<div style="width: 100%;height: 100%" id="echartsPieTwo"></div>
				</div>
			</div>
			
			<div class="echarts_c">
				<div class="echarts-line-bar">
					<div class="line_title">
						<img src="../../assets/image/icon/cnvd.png" style="width: 12px;height: 14px;margin-right: 8px;" />
						<span>CNVD收录漏洞数量年度统计</span>
					</div>
					<p style="margin-top: 10px;">
						<span>日期：</span>
						<a-date-picker mode="year" :format="dateFormat2" v-model="this.year" :open="isOpen" @panelChange="onChange2"
						 @openChange="changeOpen" @focus="isOpen=true" :allowClear="false" />
					</p>
					<div id="echartLineTwo" style="width: 100%;height: 100%;"></div>
					<p class="description">
						{{year2}}年度累计新增漏洞{{totalTwo}}条
						，平均每月新增{{midNumTwo}}条
						，新增漏洞数最高的月份{{maxMonth == '暂无'?'暂无':maxMonth + '月' }}。
					</p>
				</div>
			</div>
			
			<!-- <a-row style="margin-top: 20px;">
				<div style="padding: 27px 24px;height: 362px;background: #fff;">
					<div style="display: inline-block;width: 100%;height: 100%;position: relative;">
						<div class="box_title" style="position: absolute;left: 0;top: 0;text-align: left;z-index: 1000">
							<img src="../../assets/image/icon/cnvd.png" style="width: 12px;height: 14px;margin-right: 8px;" />
							<p style="margin-bottom: 30px;display: inline-block;">CNVD收录漏洞数量年度统计</p>
							<p>
								<span>日期：</span>
								<a-date-picker mode="year" :format="dateFormat2" v-model="this.year" :open="isOpen" @panelChange="onChange2"
								 @openChange="changeOpen" @focus="isOpen=true" />
							</p>

						</div>
						<div id="echartLineTwo" style="width: 100%;height: 100%;">

						</div>
						<p style="position: absolute;left: 0;bottom: 0" class="description">
							{{year2}}年度累计新增漏洞{{totalTwo}}条
							，平均每月新增{{midNumTwo}}条
							，新增漏洞数最高的月份{{maxMonth == '暂无'?'暂无':maxMonth + '月' }}。
						</p>
					</div> -->
					<!--<div style="display: inline-block;width: 380px;height: 100%;position: relative;">
                        <p class="box_title" style="position: absolute;left: 0;top: 0">影响对象类型统计</p>
                        <div style="width: 100%;height: 100%" id="echartsPie">

                        </div>
                    </div>-->
				<!-- </div> -->
			<!-- </a-row> -->
			<!--            <a-row style="margin-top: 20px;">-->
			<!--                <div style="padding: 27px 24px;height: 362px;background: #fff;">-->
			<!--                    <div style="display: inline-block;width: 720px;height: 100%;position: relative;" >-->
			<!--                        <div class="box_title" style="position: absolute;left: 0;top: 0;text-align: left;z-index: 1000">-->
			<!--                            <p style="margin-bottom: 30px;">漏洞类型统计</p>-->
			<!--                            <p>-->
			<!--                                <span>日期：</span>-->
			<!--                                <a-range-picker-->
			<!--                                        :default-value="[this.$moment(this.allStart, dateFormat), this.$moment(this.allend, dateFormat)]"-->
			<!--                                        :format="dateFormat"-->
			<!--                                        @change="onChange3"-->
			<!--                                />-->
			<!--                            </p>-->
			<!--                        </div>-->
			<!--                        <div id="echartBar" style="width: 100%;height: 100%;">-->

			<!--                        </div>-->
			<!--                    </div>-->
			<!--                    <div style="float: right;width: 380px;height: 100%;background: #2978c3;line-height: 275px;overflow: hidden">-->
			<!--                        <div style="display: flex;flex-wrap: wrap;height: 100%;align-content: center;justify-content: center;">-->
			<!--                            <p class="flexBox"  v-for="(item,i) in barData">-->
			<!--                                <span style="display: inline-block;width:50%;font-size: 14px;font-weight: 400;color: #fff;text-align: center">{{item.type == 0 ?'通用型':'事件型'}}</span>-->
			<!--                                <span style="display: inline-block;width:50%;font-size: 14px;font-weight: 400;color: #fff;text-align: center">{{item.count}}</span>-->
			<!--                            </p>-->
			<!--                        </div>-->
			<!--                    </div>-->
			<!--                </div>-->
			<!--            </a-row>-->
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	import moment from 'moment'
	import {
		getCountNumber,
		getNew,
		getHotBug,
		getBugLine,
		getBugPie,
		getBugPieTwo
	} from '../../api/index'
	import {
		getBugTrend,
		getBugYear,
		getBugType
	} from '../../api/bugEcharts'
	import DateUtil from "../../components/w.tool.date";
	export default {
		name: "bugEcharts",
		data() {
			return {
				// 漏洞类型
				type: {
					0: '通用型',
					1: '事件型'
				},
				// 漏洞趋势
				time1: '',
				dateFormat: 'YYYY-MM-DD',
				vulnerabilityInfos: {},
				lineDataName: [],
				lineDataValue: [],
				beginDate: '',
				endDate: '',
				bugDanger: [],
				total: null,
				midNum: null,
				highDate: null,
				maxDate: '暂无数据',
				// 影响对象类型统计
				isOpen: false,
				dateFormat2: 'YYYY',
				bugPie: [],
				lineStart: '',
				endStart: '',
				year: '',
				year2: '',
				lineName: [],
				highArr: [],
				midArr: [],
				lowArr: [],
				unNoArr: [],
				totalTwo: 0,
				midNumTwo: 0,
				maxMonth: '暂无',
				// 漏洞类型统计TOP10
				allStart: '',
				allend: '',
				barData: [],
				barName: [],
				barVal: []
			}
		},
		methods: {
			/**=============跳转到漏洞列表页面的方法================== */
			//漏洞总数跳转
			jumpListAll() {
				this.$router.push({
					name: 'bugList'
				})
			},
			jumpList(val) {
				if (val === 1) {
					this.$router.push({
						name: 'bugList',
						params: {
							i: val,
							value: 3
						}
					})
				} else if (val === 2) {
					this.$router.push({
						name: 'bugList',
						params: {
							i: val,
							value: 2
						}
					})
				} else if (val === 3) {
					this.$router.push({
						name: 'bugList',
						params: {
							i: val,
							value: 1
						}
					})
				}

			},
			// 间隔一年
			getYear(date, format) {
				let time = {
					'Y+': date.getFullYear() - 1,
					'M+': date.getMonth() + 1,
					'd+': date.getDate()
				}
				if (/(y+)/i.test(format)) {
					format = format.replace(RegExp.$1, (date.getFullYear() - 1 + '').substr(4 - RegExp.$1.length))
				}
				for (let k in time) {
					if (new RegExp('(' + k + ')').test(format)) {
						format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? time[k] : ('00' + time[k]).substr(('' + time[k]).length))
					}
				}
				return format
			},
			// 日期处理
			getFormatDate(date, format) {
				let time = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate()
				}
				if (/(y+)/i.test(format)) {
					format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
				}
				for (let k in time) {
					if (new RegExp('(' + k + ')').test(format)) {
						format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? time[k] : ('00' + time[k]).substr(('' + time[k]).length))
					}
				}
				return format
			},

			getFormatDate2(date, format) {
				let time = {
					'M+': date.getMonth(),
					'd+': date.getDate()
				}
				if (/(y+)/i.test(format)) {
					format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
				}
				for (let k in time) {
					if (new RegExp('(' + k + ')').test(format)) {
						format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? time[k] : ('00' + time[k]).substr(('' + time[k]).length))
					}
				}
				return format
			},
			// 获取当前时间
			getTime() {
				var day2 = new Date();
				day2.setTime(day2.getTime());
				this.endDate = this.getFormatDate(day2, 'yyyy-MM-dd');
				this.beginDate = DateUtil.getBeforeNumToDate(30);
				this.lineStart = this.getFormatDate(day2, 'yyyy-MM-dd');
				this.endStart = this.getFormatDate2(day2, 'yyyy-MM-dd');
				this.year = this.$moment(this.$moment(new Date()).format("YYYY"))

				this.allStart = this.getYear(day2, 'yyyy-MM-dd');
				this.allend = this.getFormatDate(day2, 'yyyy-MM-dd');
			},
			// 获取漏洞数量
			getCount() {
				getCountNumber().then(res => {
					if (res.status == 200) {
						this.vulnerabilityInfos = res.data
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 趋势日期
			onChange(date, dateString) {
				this.beginDate = dateString[0]
				this.endDate = dateString[1]
				if (dateString[0] == '' && dateString[1] == '') {
					var day2 = new Date();
					day2.setTime(day2.getTime());
					this.beginDate = this.getFormatDate(day2, 'yyyy-MM-dd');
					this.endDate = this.getFormatDate2(day2, 'yyyy-MM-dd');
				}
				this.total = null
				this.lineDataName = [], this.lineDataValue = []
				this.echartsLine()
			},
			// 年统计日期
			onChange2(date) {
				this.year = this.$moment(this.$moment(date).format('YYYY'))
				this.year2 = this.$moment(date).format('YYYY')
				this.isOpen = false
				this.lineName = [],
					this.highArr = [],
					this.midArr = [],
					this.lowArr = [],
					this.unNoArr = [],
					this.echartsLineTwo()
			},

			changeOpen(status) {
				// if(status){
				//     this.isOpen=true
				//     // this.setState({isopen: true})
				// } else {
				//     this.isOpen=false
				//     // this.setState({isopen: false})
				// }
			},
			// 类型统计TOP10
			onChange3(date, dateString) {
				this.allStart = dateString[0]
				this.allend = dateString[1]
				this.barName = [], this.barVal = []
				if (dateString[0] == '' && dateString[1] == '') {
					var day2 = new Date();
					day2.setTime(day2.getTime());
					this.allStart = this.getYear(day2, 'yyyy-MM-dd');
					this.allend = this.getFormatDate(day2, 'yyyy-MM-dd')
				}
				this.echartsBar()
			},
			// 近10个月漏洞趋势
			echartsLine() {
				var params = {
					startDate: this.beginDate,
					endDate: this.endDate
				}
				getBugTrend(params).then(res => {
					if (res.status == 200) {
						var dom = document.getElementById('echartLine');
						var myChart = this.echarts.init(dom);
						if (res.data.length == 0) {
							var max = 1
							var day2 = new Date();
							day2.setTime(day2.getTime());
							this.maxDate = this.getFormatDate(day2, 'yyyy-MM-dd');
							this.total = 0
							this.midNum = 0
						} else {
							var max = res.data[0].count
						}
						var sum = 1
						for (var i = 0; i < res.data.length; i++) {
							if (max < res.data[i].count) {
								max = res.data[i].count
								this.maxDate = res.data[i].type
								sum++
							}
							this.lineDataName.push(res.data[i].type)
							this.lineDataValue.push(res.data[i].count)
							this.total += parseInt(res.data[i].count)
							this.midNum = (this.total / parseInt(res.data.length)).toFixed(2)
						}
						if (sum == 1) {
							var day2 = new Date();
							day2.setTime(day2.getTime());
							this.maxDate = this.getFormatDate(day2, 'yyyy-MM-dd');
						}
						myChart.setOption({
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									lineStyle: {
										color: '#ddd'
									}
								},
								padding: [5, 10],
							},
							grid: {
								top: '20%',
								bottom: '15%',
								left: '5%',
								right: '12%'
							},
							xAxis: {
								type: 'category',
								name: '时间',
								data: this.lineDataName,
								boundaryGap: false,
								splitLine: {
									show: false,
									interval: 'auto',
									lineStyle: {
										color: ['#D4DFF5']
									}
								},
								axisTick: {
									show: true
								},
								axisLine: {

									lineStyle: {
										color: '#000'
									}
								},
								axisLabel: {
									margin: 10,
									textStyle: {
										fontSize: 12
									}
								}
							},
							yAxis: {
								type: 'value',
								minInterval: 1,
								name: '数量',
								splitLine: {
									lineStyle: {
										color: ['#ccc']
									}
								},
								axisTick: {
									show: true
								},
								axisLine: {
									lineStyle: {
										color: '#000'
									}
								},
								axisLabel: {
									margin: 10,
									textStyle: {
										fontSize: 12
									}
								}
							},
							series: [{

								type: 'line',
								smooth: false,
								showSymbol: false,
								symbol: 'circle',
								symbolSize: 2,
								data: this.lineDataValue,
								//渐变
								areaStyle: {
									normal: {
										color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
												offset: 0,
												color: '#acdffb'
											},
											{
												offset: 1,
												color: '#fefeff'
											}
										], false),
										shadowColor: 'rgba(195,230,255,0.1)',
										shadowBlur: 20
									}
								},
								itemStyle: {
									normal: {
										color: '#58c8da'
									}
								},
								lineStyle: {
									normal: {
										width: 2,
										color: '#c6e3fd'
									}
								}
							}]
						})
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 危险等级分布
			echartsPieTwo() {
				getBugPieTwo().then(res => {
					if (res.status == 200) {
						const bugDanger = [];
						bugDanger.push({
								value: res.data.high,
								name: '高危'
							}, {
								value: res.data.middle,
								name: '中危'
							}, {
								value: res.data.low,
								name: '低危'
							},
							// {value:res.data.unknown, name:'未知'}
						)
						var dom = document.getElementById('echartsPieTwo')
						var myChart = this.echarts.init(dom)
						myChart.setOption({
							tooltip: {
								trigger: 'item',
								formatter: "{a} <br/>{b} : {c} ({d}%)"
							},
							color: ['#e9504b', '#e9bf14', '#3899f5', '#56b590'],
							legend: {
								// selectedMode: false, // 取消图例上的点击事件
								type: 'plain',
								icon: 'circle',
								orient: 'vertical',
								right: '10%',
								top: '40%',
								align: 'left',
								itemGap: 15,
								itemWidth: 10, // 设置宽度
								itemHeight: 10, // 设置高度
								textStyle: {
									color: '#000',
								},
								data: bugDanger.map(item => item.name),
								formatter: function(name) {
									if (bugDanger && bugDanger.length) {
										for (var i = 0; i < bugDanger.length; i++) {
											if (name === bugDanger[i].name) {
												return (
													name +
													'    '+
													bugDanger[i].value +
													''
												)
											}
										}
									}
								}
							},
							series: [{
								name: '危险等级',
								type: 'pie',
								center: ['30%', '50%'],
								radius: ['50%', '80%'],
								data: bugDanger,
								itemStyle: {
									emphasis: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									}
								},
								itemStyle: {
									normal: {
										label: {
											show: false,
											formatter: '{b}:{c}\n({d}%)'
										}
									},
									labelLine: {
										show: true,
										normal: {
											length: 10,
											length2: 10,
											lineStyle: {
												width: 1
											}
										}
									}
								}
							}]
						})
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 影响对象类型统计
			echartsPie() {
				getBugPie().then(res => {
					if (res.status == 200) {
						this.bugPie.push(
							// {
							//     name:'区块链',value:res.data.blockchain
							// },
							// {
							//     name:'车联网',value:res.data.internetOfVehicles
							// },
							{
								name: '工控系统',
								value: res.data.industrialControl
							},
						)
						var dom = document.getElementById('echartsPie')
						var myChart = this.echarts.init(dom)
						var colorList = ['#3098f5', '#73ACFF', '#FDD56A', '#FDB36A', '#FD866A', '#9E87FF', '#58D5FF']
						myChart.setOption({
							color: colorList,
							title: [{
								text: '漏洞总数',
								x: 'center',
								top: '40%',
								textStyle: {
									color: '#333',
									fontSize: 16,
								}
							}, {
								text: res.data.total,
								x: 'center',
								top: '50%',
								textStyle: {
									fontSize: '22',
									color: '#333',
									foontWeight: '100',
								},
							}],
							// title: {
							//     text: '漏洞总数',
							//     subtext:res.data.total,
							//     x: 'center',
							//     top: '41%',
							//     // x: '38%',
							//     // y: '41%',
							//     textStyle: {
							//         color:"#333",
							//         fontSize: 13
							//     },
							//     subtextStyle:{
							//         color:"#333",
							//         fontSize: 40,
							//         fontWeight:500
							//     }
							// },
							legend: {
								orient: 'horizontal',
								bottom: '5%',
								data: this.bugPie,
								textStyle: {
									color: "#333",
									fontSize: 12
								}
							},
							tooltip: {
								trigger: 'item'
							},
							series: [{
								type: 'pie',
								center: ['50%', '50%'],
								radius: ['36%', '50%'],
								clockwise: true,
								avoidLabelOverlap: true,
								hoverOffset: 15,
								itemStyle: {
									normal: {
										color: function(params) {
											return colorList[params.dataIndex]
										}
									}
								},
								label: {
									show: true,
									position: 'outside',
									formatter: '{a|{b}:{d}%}\n{hr|}',
									rich: {
										hr: {
											backgroundColor: 't',
											borderRadius: 3,
											width: 3,
											height: 3,
											padding: [3, 3, 0, -12]
										},
										a: {
											padding: [-30, 15, -20, 15]
										}
									}
								},
								labelLine: {
									normal: {
										length: 10,
										length2: 10,
										lineStyle: {
											width: 1
										}
									}
								},
								data: this.bugPie,
							}]
						})
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}

				})

			},

			echartsLineTwo() {
				var params = {
					year: this.$moment(this.year).format("YYYY")
				}
				getBugYear(params).then(res => {
					if (res.status == 200) {
						var dom = document.getElementById('echartLineTwo');
						var myChart = this.echarts.init(dom);
						var num=0
						var max=parseInt(JSON.parse(res.data[0].high)) + parseInt(JSON.parse(res.data[0].middle)) +  parseInt(JSON.parse(res.data[0].low)) + parseInt(JSON.parse(res.data[0].unknown));
						var min=0
						this.maxMonth = 1
						for(var i=0;i<res.data.length;i++){
						    min = parseInt(JSON.parse(res.data[i].high)) + parseInt(JSON.parse(res.data[i].middle)) +  parseInt(JSON.parse(res.data[i].low)) + parseInt(JSON.parse(res.data[i].unknown))
						    if(max < min){
						        max = min
						        this.maxMonth=res.data[i].time
						    }
						     this.highArr.push(res.data[i].high),
						     this.lineName.push(res.data[i].time),
						     this.midArr.push(res.data[i].middle),
						     this.lowArr.push(res.data[i].low),
						     this.unNoArr.push(res.data[i].unknown)
						     num += parseInt(JSON.parse(res.data[i].high)) + parseInt(JSON.parse(res.data[i].middle)) +  parseInt(JSON.parse(res.data[i].low)) + parseInt(JSON.parse(res.data[i].unknown))
						     this.totalTwo = num
						     this.midNumTwo=(num/parseInt(res.data.length)).toFixed(2)
						}
						myChart.setOption({
							color: ["#f34f4e", "#eebd34", "#009ef3"],
							tooltip: {
								trigger: 'axis',
								axisPointer: { // 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								}
							},
							legend: {
								data: ['高危', '中危', '低危'],
								// left: 'center',
								top:'5%',
								right:'2%',
								type: 'plain',
								icon: 'circle',
							},
							grid: {
								left: 0,
								right: '4%',
								top:'20%',
								bottom: '7%',
								containLabel: true
							},
							xAxis: [{
								type: 'category',
								data:this.lineName,
							}],
							yAxis: [{
								type: 'value'
							}],
							series: [
								{
									name: '高危',
									barWidth:20,
									type: 'bar',
									stack: '广告',
									emphasis: {
										focus: 'series'
									},
									data: this.highArr,
								},
								{
									name: '中危',
									barWidth:20,
									type: 'bar',
									stack: '广告',
									emphasis: {
										focus: 'series'
									},
									data: this.midArr,
								},
								{
									name: '低危',
									barWidth:20,
									type: 'bar',
									stack: '广告',
									emphasis: {
										focus: 'series'
									},
									data: this.lowArr,
								},
							]
						})
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})

			},
			// 类型统计TOP10
			echartsBar() {
				var params = {
					startDate: this.allStart,
					endDate: this.allend,
				}
				getBugType(params).then(res => {
					if (res.status == 200) {
						var dom = document.getElementById('echartBar');
						var myChart = this.echarts.init(dom);
						if (res.data.length == 0) {
							this.barData = 0;
						} else {
							for (var i = 0; i < res.data.length; i++) {
								this.barData = res.data
								if (res.data[i].type == 0) {
									this.barName.push('通用型')
									this.barVal.push(res.data[i].count)
								} else {
									this.barName.push('事件型')
									this.barVal.push(res.data[i].count)
								}
							}
						}
						myChart.setOption({
							color: ['#3398DB'],
							tooltip: {
								trigger: 'axis',
								axisPointer: { // 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								}
							},
							grid: {
								top: '40%',
								bottom: '20%',
								left: '8%',
								right: '12%',
								containLabel: true
							},
							xAxis: [{
								type: 'category',
								data: this.barName,
								axisTick: {
									alignWithLabel: true
								}
							}],
							yAxis: [{
								type: 'value'
							}],
							series: [{
								type: 'bar',
								barWidth: '60%',
								data: this.barVal
							}]
						})
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
		},
		created() {
			this.getCount()
			this.getTime()
		},
		mounted() {
			this.echartsLine();
			this.echartsLineTwo()
			this.echartsPieTwo()
			// this.echartsPie()
			// this.echartsBar();
		}
	}
</script>

<style scoped>
	/* 数量统计 */
	.quantity-statistics-box {
		width: 100%;
		height: 116px;
		background-color: #f7f8fa;
	}
	/* common */
	.width-1200 {
		height: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.number-list {
		width: 364px;
		height: 81%;
		border-left: 1px solid #e8e8e8;
		padding-left: 20px;
		cursor: pointer;
	}
	.number-list1{
		width: 108px;
		height: 81%;
		border-left: 1px solid #e8e8e8;
		padding-left: 20px;
		cursor: pointer;
	}
	.number-name {
		font-size: 14px;
		color: #333333;
		text-align: left;
		font-family: "PingFangSC-Regular";
		/* margin-bottom: 16px; */
	}
	.num-total {
		font-size: 42px;
		color: #000000;
		text-align: left;
		font-family: "DIN-Medium";
	}
	.content-box {
		width: 100%;
		background-color: #fff;
	}

	.banner {
		width: 100%;
		height: 290px;
		background: url("../../assets/image/banner/statis.png") center center no-repeat;
		background-size: cover;display: flex;
		justify-content: center;
		align-items: center;
	}

	.banner_title {
		width: 300px;
		height: 117px;
		background-color: rgba(6, 77, 166, 0.3);
		/* background-color: #064da6; */
		/* opacity: 0.3; */
		text-align: center;
	}

	.big {
		height: 36px;
		font-family: MicrosoftYaHei-Bold;
		font-size: 36px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 13px;
		letter-spacing: 4px;
		margin-top: 35px;
		color: #fefefe;
		/* box-shadow: 0px 1px 0px 0px 
				rgba(41, 47, 49, 0.39); */
	}
	.min {
		height: 14px;
		font-family: PingFangSC-Semibold;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 13px;
		letter-spacing: 1px;
		color: #f4f1f1;
		margin-top: 10px;
		z-index: 999;
		/* box-shadow: 0px 1px 0px 0px 
					rgba(41, 47, 49, 0.39); */
	}


	.banner-img {
		margin: 0 auto;
		width: 15%;
		display: flex;
		align-items: center;
		height: 290px;
		/* height: 100px; */
	}

	.banner-img img {
		width: 100%;
		height: auto;
		align-items: center;
	}

	p {
		margin-bottom: 0px;
	}

	.num {
		font-size: 40px;
		font-weight: 700;
		line-height: 40px;
		text-align: center;
		margin-top: 15px;
		color: #333;
	}

	.name {
		font-size: 14px;
		font-weight: 700;
		color: #333;
		line-height: 14px;
		margin-top: 20px;
		text-align: center;
	}

	.box_title {
		font-size: 14px;
		line-height: 14px;
		color: #141414;
		font-weight: 700;
		margin-bottom: 30px;
	}

	.description {
		width: 720px;
		font-size: 14px;
		line-height: 24px;
		font-weight: 400;
		color: #888888;
		border: solid 1px #fcdab5;
		height: 28px;
		line-height: 28px;
		padding: 0 0 0 10px;
	}

	.flexBox {
		display: inline-block;
		width: 50%;
		height: 45px;
		line-height: 45px;
		border-right: 1px solid #6299ce;
		border-bottom: 1px solid #6299ce;
		flex: 0 0 50%
	}
	
	.echarts_c {
		width: 100%;
		height: 350px;
		margin-top: 30px;
		margin-bottom: 30px;
		display: flex;
		justify-content: space-between;
	}
	
	.echarts-line {
		width: 720px;
		height: 250px;
		text-align: left;
	}
	
	.echarts-line-bar{
		width: 720px;
		height: 250px;
		text-align: left;
	}
	
	.echarts-pie {
		width: 454px;
		height: 250px;
	}
	
	.line_title,
	.pie_title {
		text-align: left;
		font-size: 14px;
		font-weight: bold;
		height: 30px;
		line-height: 30px;
	}
	
	.line_title img,
	.pie_title img {
		margin-right: 5px;
	}
</style>
